import React from "react";
import IconTimeout from "../componentsStyled/icon/icontimeout";
import { Box, Button, Modal } from "@mui/material";

interface ModalTimeoutProps {
  isOpen: boolean;
  children?: React.ReactNode;
  onRequestClose: () => void;
}

const ModalTimeout: React.FC<ModalTimeoutProps> = ({ isOpen, onRequestClose }) => {
  const handleRedirect = () => {
    window.location.href = "/";
  };
  return (
    <Modal
      open={isOpen}
      onClose={onRequestClose}
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 350,
        height: 300,
        bgcolor: "#fff",
        boxShadow: 24,
        "& .MuiBackdrop-root": { backgroundColor: "transparent" },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        borderRadius: 10,
      }}>
      <Box width={300} display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"} textAlign={"center"}>
        <IconTimeout width={60} />
        <p style={{ fontSize: 22 }}>Tempo esgotado</p>
        <p>Por questões de segurança, a sessão tem um tempo de validade. Para continuar, refaça seu login clicando abaixo.:</p>
        <Button variant="contained" style={{ backgroundColor: "#000" }} onClick={handleRedirect}>
          Refazer login
        </Button>
      </Box>
    </Modal>
  );
};

export default ModalTimeout;
